import * as React from 'react';

function Padlock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M19 10.857h-2.333V8.571C16.667 6.047 14.577 4 12 4S7.333 6.047 7.333 8.571v2.286H5V20h14v-9.143zm-4.667 0H9.667V8.571c0-1.262 1.044-2.285 2.333-2.285 1.289 0 2.333 1.023 2.333 2.285v2.286z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Padlock;
